<script setup>
import {CONTACT_INFO, getMapLinks, PRACTICE_NAME, THERAPIST_NAME} from "@/content/site";
import ContactCard from "@/app/components/common/ContactCard.vue";

/* eslint-disable no-undef */
defineProps({
  noBox: {
    type: Boolean,
    default: false,
  },
});

const mapLinks = getMapLinks()

</script>

<template>
  <section class="section">
    <h2>Kontakt</h2>

    <div class="contact-info">
      <div class="contact-column">
        <ContactCard title="E-Mail" class="contact-card" :value="CONTACT_INFO.email" :link="`mailto:${CONTACT_INFO.email}`" icon="" :noBox/>
        <ContactCard title="Telefon" class="contact-card" :value="CONTACT_INFO.phone" :link="`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`" :noBox/>
      </div>

      <div class="contact-item contact-item-address">
        <ContactCard title="Adresse" icon="" :noBox>
          <p class="contact-text">{{ PRACTICE_NAME }}</p>
          <p class="contact-text">{{ THERAPIST_NAME }}</p>
          <p class="contact-text">{{ CONTACT_INFO.address.street }}</p>
          <p class="contact-text">{{ CONTACT_INFO.address.zipCity }}</p>
        </ContactCard>
      </div>
    </div>

    <div class="location-info">
      <p>
        Sie finden meine Praxis im Herzen des Rheingaus, fußläufig vom Bahnhof.
        Parkplätze sind an der Straße vorhanden. Die Praxis befindet sich im
        Hochparterre.
      </p>
    </div>

    <div class="map-container" :class="{ 'blurred-background': !noBox }">
      <img
        src="@/assets/images/map.png"
        width="100%"
        height="400"
        style="border: 0"
        class="map-image"
        alt=""/>
      <div class="map-nav-redirect-bar">
        <div class="map-link-container">
          <a :href="mapLinks.google" target="_blank" rel="noopener">Google Maps</a>
          <a :href="mapLinks.apple" target="_blank" rel="noopener">Apple Maps</a>
          <a :href="mapLinks.osm" target="_blank" rel="noopener">OpenStreetMap</a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contact-info {
  display: flex;
  gap: var(--spacing-sm);
}

.contact-column {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  flex: 1;
}

.contact-card {
  flex: 1 1 auto;
}

.contact-text {
  line-height: var(--line-height-tight);
}

.contact-item-address {
  flex: 1;
}

.location-info {
  text-align: center;
}

.section h2 {
  font-size: var(--font-size-xxl);
  color: var(--color-cream);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);
  text-align: left;
  margin: 0 0 var(--spacing-sm) 0;
  padding-left: var(--spacing-md);
}

.location-info p {
  font-size: var(--font-size-m);
  color: var(--color-cream);
  line-height: var(--line-height-body);
  margin: 0;
}

.map-container {
  border-radius: var(--box-border-radius);
  overflow: hidden;
}

.map-container.blurred-background {
  padding: var(--spacing-sm);
}

.map-image {
  display: block;
  width: 100%;
  border-radius: var(--box-border-radius);
  object-fit: cover;
}

.map-nav-redirect-bar {
  display: flex;
  width: 100%;
  margin-top: var(--spacing-sm);
}

.map-link-container {
  display: flex;
  flex: auto;
  align-items: center;
  margin: 0 var(--spacing-xl);
  border-radius: var(--box-border-radius);
  height: 3rem;

  background-color: var(--box-bg);
}

.map-nav-redirect-bar p {
  flex: auto;

  font-size: var(--font-size-m);
  font-weight: var(--font-weight-semibold);
  color: var(--color-cream);
  transition: color var(--transition-fast);
}

.map-link-container a {
  flex: auto;
  font-size: var(--font-size-m);
  color: var(--color-cream);
  text-decoration: none;
  transition: color var(--transition-fast);
  line-height: var(--line-height-compact);
}

.map-link-container a:hover {
  transition: color var(--transition-fast);
  color: var(--color-cream-dark);
}

@media (max-width: 768px) {

  .map-link-container {
    flex-direction: column;
    height: auto;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing-md);
    margin: 0;
  }

  .contact-info {
    flex-direction: column;
    gap: var(--spacing-xxs);
  }

  .contact-column {
    gap: var(--spacing-xxs);
  }
}

</style>
